import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAllLeadsResponse, ILead, ILeadStats, INewLead, ISingleLeadRespose } from "../models/Lead";
import { DefaultResponseWithData } from "../models/system";
import apiConfig from "../utils/apiConfig";

export default function useLeadStats(componentName = "useLeadStats") {
  const { get, getFile, post, postGetFile, put, del } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const leadStats = useQuery({
    queryKey: ["stats", "leads"],
    queryFn: () => get<DefaultResponseWithData<ILeadStats>>("/stats/leads"),
    staleTime: 1000 * 60 * 10, // 10 minutes
  });

  return {
    leadStats,
  };
}
